// Simple hash function to convert seed string to number
export const hashSeed = (seed: string): number => {
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i)
    hash = hash & hash // Convert to 32bit integer
  }
  return Math.abs(hash)
}

// Seeded random number generator using LCG algorithm
export const createSeededRandom = (seed: string) => {
  const seedNum = hashSeed(seed)
  // Use seed to initialize a simple PRNG state
  let state = seedNum

  return () => {
    state = (state * 1664525 + 1013904223) % 2 ** 32
    return (state >>> 0) / 2 ** 32
  }
}
